import ApplicationController from './application_controller'
import noUiSlider from 'nouislider'

export default class extends ApplicationController {

	static targets = [
		'slider',
		'inputRangeStart',
		'inputRangeEnd',
		'labelRangeStart',
		'labelRangeEnd',
	]

	static values = {
		startRange:     { type: Array,   default: [20, 180] },
		range:          { type: Object,  default: { 'min': 0, 'max': 200 } },
		step:           { type: Number,  default: 1 },
		showPips:       { type: Boolean, default: false },
		showTooltips:   { type: Boolean, default: false },
		submitOnChange: { type: Boolean, default: true },
	}

	connect() {
		const options = {
			start:    this.startRangeValue,
			connect:  true,
			range:    this.rangeValue,
			step:     this.stepValue,
			tooltips: this.showTooltipsValue,
		}

		if (this.showPipsValue) {
			options.pips = {
				mode: 'range',
				density: 3,
			}
		}

		this.noUiSlider = noUiSlider.create(this.sliderTarget, options)

		for (const connectElement of this.sliderTarget.querySelectorAll('.noUi-connect')) {
			connectElement.classList.add('bg-primary')
		}

		this.noUiSlider.on('update', (values, handle) => {
			if (!this.isConnected) { return }

			if (handle == 0) {
				this.inputRangeStartTarget.value = parseInt(values[0])
			}
			if (handle == 1) {
				this.inputRangeEndTarget.value = parseInt(values[1])
			}
			if (handle == 0) {
				if (this.hasLabelRangeStartTarget) { this.labelRangeStartTarget.innerHTML = parseInt(values[0]) }
			}
			if (handle == 1) {
				if (this.hasLabelRangeEndTarget) { this.labelRangeEndTarget.innerHTML = parseInt(values[1]) }
			}
		})
		
		this.noUiSlider.on('change', (values, handle) => {
			if (this.isConnected && this.submitOnChangeValue) { this.element.closest('form').requestSubmit() }
		})

		this.isConnected = true
	}

	disconnect() {
		this.noUiSlider.destroy()
	}
}

